import { filter, orderBy } from 'lodash'

export const getAvailableProjectTransfersForMultiselect = (
  punchCard: Partial<MData.PunchCard> | undefined,
  selectedShift: Partial<MData.Event> | undefined,
  userInfo: Partial<MData.CurrentUser['userInfo']>,
  projectsById: { [x: string]: Partial<MData.Project> }
) => {
  const userProjects = userInfo?.projects
  if (!userProjects) return []
  const currentProjectId = getCurrentProjectId(punchCard, selectedShift)
  const filteredUserProjects = userProjects?.filter(projectId => projectId !== currentProjectId)
  const projectOptions = filteredUserProjects.map(projectId => ({ value: projectsById?.[projectId]?._id, label: projectsById?.[projectId]?.name }))

  return orderBy(projectOptions, ['name'])
}

const getCurrentProjectId = (punchCard: Partial<MData.PunchCard> | undefined, selectedShift: Partial<MData.Event> | undefined) => {
  if (!punchCard) return null
  const projectTransfers = filter(punchCard.transfers, transfer => transfer.toProject) as MData.Transfer[]
  const lastProjectTransfer = projectTransfers.pop()
  return lastProjectTransfer ? lastProjectTransfer.toProject : selectedShift?.projects?.[0]
}
